import type { FormSchema, GeneratorOptions } from '@cli-types/core-engine/schema.js'
import type { StepResult } from '@cli-types/next-adapter/forms.js'

export function generateSingleStepForm(
  _schema: FormSchema,
  _cwd: string,
  _adminDir: string,
  _options: GeneratorOptions
): StepResult {
  return { files: [] }
}
